import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '../..';
import Theme from '../../Theme';
/** Lookup object for icon name from status. */

var statusToIconName = {
  loading: 'circle-notch',
  info: 'info',
  success: 'check-mark',
  warning: 'exclamation-mark',
  error: 'cross',
  search: 'search'
};
/**
 * Renders a status badge for an input.
 *
 * @param {string} status - The status to display.
 *
 * @return {jsx}
 */

var Status = function Status(_ref) {
  var className = _ref.className,
      status = _ref.status;
  var color = useMemo(function () {
    if (['loading'].includes(status)) {
      return Theme.palette.primary["default"];
    }

    if (['search'].includes(status)) {
      return Theme.palette.darkGrey;
    }

    return Theme.palette.white;
  }, [status]);
  var size = useMemo(function () {
    if (['loading', 'info', 'warning'].includes(status)) {
      return '2rem';
    }

    if (['search'].includes(status)) {
      return '1.33rem';
    }

    return '1rem';
  }, [status]);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-testid": "status"
  }, /*#__PURE__*/React.createElement(Icon, {
    color: color,
    name: statusToIconName[status],
    size: size
  }));
};
/** Display name. */


Status.displayName = 'Input.Status';
/** Props types. */

var string = PropTypes.string;
Status.propTypes = {
  className: string,
  status: string.isRequired
};
/** Default props. */

Status.defaultProps = {
  className: ''
};
export default styled(Status).withConfig({
  displayName: "Status",
  componentId: "sc-1grr13g-0"
})(["display:flex;align-items:center;justify-content:center;width:1.8rem;height:1.8rem;margin-right:", ";border-radius:50%;", ";", ";", ";", ";", ";", ";", ";"], function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.small;
}, function (_ref3) {
  var status = _ref3.status;
  return status === 'loading' && css(["background:", ";"], function (_ref4) {
    var palette = _ref4.theme.palette;
    return palette.white;
  });
}, function (_ref5) {
  var status = _ref5.status;
  return status === 'info' && css(["background:", ";"], function (_ref6) {
    var palette = _ref6.theme.palette;
    return palette.primary["default"];
  });
}, function (_ref7) {
  var status = _ref7.status;
  return status === 'success' && css(["background:", ";"], function (_ref8) {
    var palette = _ref8.theme.palette;
    return palette.success["default"];
  });
}, function (_ref9) {
  var status = _ref9.status;
  return status === 'warning' && css(["background:", ";"], function (_ref10) {
    var palette = _ref10.theme.palette;
    return palette.warning["default"];
  });
}, function (_ref11) {
  var status = _ref11.status;
  return status === 'error' && css(["background:", ";"], function (_ref12) {
    var palette = _ref12.theme.palette;
    return palette.failure["default"];
  });
}, function (_ref13) {
  var status = _ref13.status;
  return status === 'search' && css([""]);
}, function (_ref14) {
  var status = _ref14.status,
      hasFocus = _ref14.hasFocus;
  return status === 'search' && hasFocus && css([""]);
});